import { Option as ComboBoxOption, FlexibleScope } from 'types/types'

export const LAYOUT_CONFIG = {
  LEFT_COLUMN_WIDTH: '25%',
  RIGHT_COLUMN_WIDTH: '75%',
  GROUP_WIDTH: 350,
  GROUP_GAP: 24,
  GROUP_TOTAL_WIDTH: 374 // GROUP_WIDTH + GROUP_GAP
} as const

export const calculateScrollAmount = () => LAYOUT_CONFIG.GROUP_TOTAL_WIDTH

export const calculateMinWidth = (groupCount: number) => `${groupCount * LAYOUT_CONFIG.GROUP_TOTAL_WIDTH}px`

export const getRowBackgroundColor = (index: number) => (index % 2 === 0 ? 'bg-white' : 'bg-background-grid-row')

export const contractTiers = {
  koneCareDxPro: 'kone_care_dx_pro',
  koneCareDx: 'kone_care_dx',
  koneCareDxLight: 'kone_care_dx_light',
  koneCare: 'kone_care'
} as const
export const defaultContractScope = contractTiers.koneCareDx

export const defaultStartsPerYear = '1'

/**
 * Contract type labels mapping
 */
const CONTRACT_TYPE_LABELS: Record<string, string> = {
  [contractTiers.koneCareDxPro]: 'Kone Care DX Pro',
  [contractTiers.koneCareDx]: 'Kone Care DX',
  [contractTiers.koneCareDxLight]: 'Kone Care DX Light',
  [contractTiers.koneCare]: 'Kone Care',
  // Legacy types for backward compatibility
  premium: 'Premium',
  premium_minus: 'Premium Minus',
  standard_plus: 'Standard Plus',
  standard: 'Standard',
  standard_minus: 'Standard Minus',
  low_end: 'Low End',
  resiflow: 'Resiflow'
}

/**
 * Desired order for contract types in dropdown
 */
const CONTRACT_TYPE_ORDER = [
  contractTiers.koneCareDxPro,
  contractTiers.koneCareDx,
  contractTiers.koneCareDxLight,
  contractTiers.koneCare
]

/**
 * Gets formatted and sorted contract type dropdown options
 * Filters out 'kone_care_dx_light' for escalator service type
 *
 * @param scopes - Available contract type scopes
 * @param serviceType - Current service type (elevator or escalator)
 * @returns Sorted and formatted dropdown options
 */
export const getContractTypeOptions = (
  scopes: FlexibleScope[] | undefined,
  serviceType: 'elevator' | 'escalator'
): ComboBoxOption[] => {
  if (!scopes) {
    return []
  }

  return scopes
    .filter(type => {
      // Remove 'kone_care_dx_light' for escalator service type
      if (serviceType === 'escalator' && type === contractTiers.koneCareDxLight) {
        return false
      }
      return true
    })
    .sort((a, b) => {
      // Sort by the defined order
      const indexA = CONTRACT_TYPE_ORDER.indexOf(a)
      const indexB = CONTRACT_TYPE_ORDER.indexOf(b)

      // If both are in the order array, sort by their position
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB
      }

      // If only one is in the order array, it comes first
      if (indexA !== -1) {
        return -1
      }
      if (indexB !== -1) {
        return 1
      }

      // Otherwise keep original order
      return 0
    })
    .map(type => ({
      key: type,
      value: CONTRACT_TYPE_LABELS[type] || type
    }))
}
